export default {"src":"/_next/static/media/dog_64.84068386.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};